<template>
  <div class="head" >
    <div class="bj" @click="ispc=false">  </div>
    <div class="click-bj" style="width: 100%; height: 100vh;" v-if="states && ispc"   @click="ispc=false" @touchstart="ispc=false">  </div>

    <div class="logo"  @click="navigation(1)" ></div>

    <div class="menu" v-if="states" @click="menuclick()"></div>
    <!--<div class="navigation  111" v-else>-->
      <!--<ul style=" width: 37%;  height: 100%;  background: #000; display: inline-block; padding: 0;">-->
        <!--<li @click="navigation(1)"  :class="{'show2':isshow==1}">主页</li>-->
        <!--<li @click="navigation(2)" :class="{'show2':isshow==2}">产品</li>-->
          <!--<ul v-if="!ispc" v-show=" floatisshow ==2 || (isshow==2  && ismain )" >-->
            <!--<li @click="navigation(7)"  @mouseenter="selection(7)"  @mouseleave="selection(0)" :class="{'show':isshow==7 ,'show2':floatisshow==7}">Social CRM</li>-->
            <!--<li @click="navigation(8)"  @mouseenter="selection(8)"  @mouseleave="selection(0)" :class="{'show':isshow==8 ,'show2':floatisshow==8}">B2B营销平台</li>-->
            <!--<li @click="navigation(10)" @mouseenter="selection(10)"  @mouseleave="selection(0)" :class="{'show':isshow==10 ,'show2':floatisshow==10}">企业营销直播系统</li>-->
            <!--<li @click="navigation(9)"  @mouseenter="selection(9)"  @mouseleave="selection(0)" :class="{'show':isshow==9 ,'show2':floatisshow==9}">社群营销系统</li>-->
          <!--</ul>-->
        <!--<li @click="navigation(3)" :class="{'show2':isshow==3}">服务</li>-->
        <!--<li @click="navigation(4)" :class="{'show2':isshow==4}">案例</li>-->
        <!--<li @click="navigation(5)" :class="{'show2':isshow==5}">加入我们</li>-->
        <!--<li @click="navigation(6)" :class="{'show2':isshow==6}">关于我们</li>-->
      <!--</ul>-->
    <!--</div>-->
    <div class="line" v-if="!states">  </div>
    <!--<div class="two-level-menu" v-show="isshow==2 ||isshow==3 ||isshow==4">-->

    <div class="two-level-menu " v-if="!states" >

      <ul v-show=" floatisshow ==2 ||floatisshow ==7 ||floatisshow ==8 ||floatisshow ==9 ||floatisshow ==10 || (isshow==2  && ismain )">
      <!--<ul >-->
        <li @click="navigation(7)"  @mouseenter="selection(7)"  @mouseleave="selection(0)" :class="{'show':isshow==7 ,'show2':floatisshow==7}">Social CRM</li>
        <li @click="navigation(8)"  @mouseenter="selection(8)"  @mouseleave="selection(0)" :class="{'show':isshow==8 ,'show2':floatisshow==8}">B2B营销平台</li>
        <li @click="navigation(10)" @mouseenter="selection(10)"  @mouseleave="selection(0)" :class="{'show':isshow==10 ,'show2':floatisshow==10}">企业营销直播系统</li>
        <li @click="navigation(9)"  @mouseenter="selection(9)"  @mouseleave="selection(0)" :class="{'show':isshow==9 ,'show2':floatisshow==9}">社群营销系统</li>

      </ul>

    </div>
    <div class="navigation"  v-if="!states" >

      <ul>
        <li @click="navigation(1)"   @mouseenter="selection(1)"  @mouseleave="selection(0)" :class="{'show':isshow==1 ,'show2':floatisshow==1}">主页</li>
        <li @click="navigation(2)"  @mouseenter="selection(2)"  @mouseleave="selection(0)"  :class="{'show':isshow==2, 'show2 upper':floatisshow==2,'upper':floatisshow==7||floatisshow==8||floatisshow==9||floatisshow==10,'lower':floatisshow!=(2||7||8||9||10),'upper':ismain} ">产品  </li>
        <li @click="navigation(3)" @mouseenter="selection(3)"  @mouseleave="selection(0)" :class="{'show':isshow==3 ,'show2':floatisshow==3}">服务</li>
        <li @click="navigation(4)" @mouseenter="selection(4)"  @mouseleave="selection(0)" :class="{'show':isshow==4 ,'show2':floatisshow==4}">案例</li>
        <li @click="navigation(5)" @mouseenter="selection(5)"  @mouseleave="selection(0)" :class="{'show':isshow==5 ,'show2':floatisshow==5}">加入我们</li>
        <li @click="navigation(6)" @mouseenter="selection(6)"  @mouseleave="selection(0)" :class="{'show':isshow==6 ,'show2':floatisshow==6}">关于我们</li>
      </ul>
    </div>


    <div class="navigation"  v-if="states"  v-show="ispc"  @click.stop="ispc=true" @touchstart.stop="ispc=true">
      <div class="bj"></div>
      <ul>
        <li @click.stop="navigation(1)"  :class="{'show':isshow==1 ,'show2':floatisshow==1}">主页</li>
        <li @click.stop="navigation(2)" :class="{'show':isshow==2,'lower':!ismain,'upper':ismain} ">产品  </li>
        <ul v-show=" isshow==2  && ismain">
        <li  @click.stop="navigation(7)"  :class="{'show':isshow==7 }">Social CRM</li>
        <li  @click.stop="navigation(8)"  :class="{'show':isshow==8 }">B2B营销平台</li>
        <li  @click.stop="navigation(10)"  :class="{'show':isshow==10 }">企业营销直播系统</li>
        <li  @click.stop="navigation(9)" :class="{'show':isshow==9 }">社群营销系统</li>
        </ul>
        <li @click.stop="navigation(3)" :class="{'show':isshow==3 }">服务</li>
        <li @click.stop="navigation(4)"  :class="{'show':isshow==4 }">案例</li>
        <li @click.stop="navigation(5)"  :class="{'show':isshow==5 }">加入我们</li>
        <li @click.stop="navigation(6)"  :class="{'show':isshow==6 }">关于我们</li>
      </ul>
    </div>

  </div>
</template>

<script>

export default {
  name: 'Homehead',
    data() {
      return {
        isshow: 0,
        floatisshow: 0,
        states: '',
        ispc:true,
        ismain:false,
      }
  },
  components: {
  
  },
    methods: {
      menuclick() {
        if (this.ispc) {
          this.ispc = false;
        } else {
         this.ispc = true;
        }
      },
    navigation(id) {
      var _this = this;

      _this.isshow = id;
      if (id==1) {
        _this.$router.push('/');
      }else  if (id==3) {
        _this.$router.push('/service');
      }else  if (id==4) {
        _this.$router.push('/cases');
      }else  if (id==5) {
        _this.$router.push('/joinus');
      }else  if (id==6) {
        _this.$router.push('/aboutus');
      }else  if (id==7) {
        _this.$router.push('/product1');
      }else  if (id==8) {
        _this.$router.push('/product3');
      }else  if (id==9) {
        _this.$router.push('/product2');
      }else  if (id==10) {
        _this.$router.push('/product4');
      }

     if (id==2) {
         if (_this.ismain) {
           _this.ismain = false;
         } else {
           _this.ismain = true;
         }
       }else{
         _this.ismain = false;

          this.ispc = false;
       }

    },
      selection(id){
        this.floatisshow = id;
        console.log('高亮',this.isshow )
      }
    },
    created() {
      this.states = state;
      if (state) {
        this.ispc = false;
      }
      var _this=this;
      var url=window.location.href;

      if(url.indexOf("product4") != -1 ){
        _this.isshow = 2;
      }else if(url.indexOf("product2") != -1 ){
        _this.isshow = 2;
      }else if(url.indexOf("product3") != -1 ){
        _this.isshow = 2;
      }else if(url.indexOf("product1") != -1 ){
        _this.isshow = 2;
      }else if(url.indexOf("aboutus") != -1 ){
        _this.isshow = 6;
      }else if(url.indexOf("joinus") != -1 ){
        _this.isshow = 5;
      }else if(url.indexOf("cases") != -1 ){
        _this.isshow = 4;
      }else if(url.indexOf("service") != -1 ){
        _this.isshow = 3;
      }else if(url.indexOf("/") != -1 ){
        _this.isshow = 1;
      }
    console.log('值3',state)
      
    },

  watch:{
    $route(to,from){
      console.log('跳轉1',window.location.href);
      var _this=this;
      var url=window.location.href;
      if(this.states){
        console.log('this.states',this.states);
        this.ispc = false;
      }

      if(url.indexOf("product4") != -1 ){
        _this.isshow = 2;
      }else if(url.indexOf("product2") != -1 ){
        _this.isshow = 2;
      }else if(url.indexOf("product3") != -1 ){
        _this.isshow = 2;
      }else if(url.indexOf("product1") != -1 ){
        _this.isshow = 2;
      }else if(url.indexOf("aboutus") != -1 ){
        _this.isshow = 6;
      }else if(url.indexOf("joinus") != -1 ){
        _this.isshow = 5;
      }else if(url.indexOf("cases") != -1 ){
        _this.isshow = 4;
      }else if(url.indexOf("service") != -1 ){
        _this.isshow = 3;
      }else if(url.indexOf("/") != -1 ){
        _this.isshow = 1;
      }
    }
  },



}
  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"   scoped>
 

  img{
    width:100%;
    height:auto;
    display: block;
  }
  .head{
    width:100%;
    height:2.54rem;
    position: absolute;
    top: 0;
    z-index: 10;
 
    .bj{
    width:100%;
    height:90%;
    background: #000000;
    opacity:0.4;
  }
  .logo{
    position: absolute;
    top: .3rem;
    left: 2rem;
    width: 1.25rem;
    height: 1.25rem;
    z-index: 10;
    background:url("../../assets/img/HomePage/head/logo.png") no-repeat;
    background-size: 100% 100%;
    cursor:pointer;
  }
  .navigation{
    font-size: .3rem;
    position: absolute;
    top: 0.9rem;
    right: 2.08rem;
    color: #cacaca;
    z-index: 10;
    ul{
      list-style: none;
      margin-left: 50px;
      li{
        display: inline;
        float:left;
        padding: 0 .3rem;
        cursor:pointer;
        height: .7rem;
      }

    }
  }
    .show{
      color: #fff;
      font-weight: bold;
      cursor:pointer;
    }
    .show2{
      color: #fff;
      font-weight: bold;
      cursor:pointer;
    }
  .line {
    position: absolute;
    top: 1.7rem;
    width: 100%;
    height: 2px;
    background: #f9f6f6;
       opacity:0.4;
  }
  .two-level-menu {
    font-size: .23rem;
    position: absolute;
    top: 1.6rem;
    right: 2.08rem;
    color: #cacaca;
    z-index: 10;
    ul{
      list-style: none;
      margin-left: 50px;
      li{
        display: inline;
        /*line-height: 40px;*/
        float:left;
        padding: 0 .3rem;
      }
    }
  }
  .bgimg{
    width:100%;
    height:auto;
  }
  }
  .lower::before {
    position: absolute;
    /*top: .3rem;*/
    /*right: 5.2rem;*/
    top: .45rem;
    right: 6rem;
    content: "";
    width: .2rem;
    height: .1rem;
    background: url(../../assets/img/HomePage/head/lower.png) left top / 100% 100% no-repeat;
  }

  .upper::before {
    position: absolute;
    /*top: .3rem;*/
    /*right: 5.2rem;*/
    top: .45rem;
    right: 6rem;
    content: "";
    width: .2rem;
    height: .1rem;
    background: url(../../assets/img/HomePage/head/upper.png) left top / 100% 100% no-repeat;
  }

  @media screen and (max-width:750px) {
   .logo{
     top: .15rem !important;
    left: .47rem !important;
    width: .64rem !important;
    height: .54rem !important;
  }
    .head {
      height:.83rem;
      .line{
        top:.83rem !important;
        }
    }
    .menu {
    position: absolute;
    top: .25rem;
    right: .47rem;
    height: .33rem;
    width: .35rem;
    
    z-index: 10;
    background:url("../../assets/img/HomePage/head/daohang.png") no-repeat;
    background-size: auto 100%;
    }
    .navigation {
      width: 50%;
          right: 0!important;
          top: .7rem!important;
      color: #fff!important;
      font-size: .35rem;
      .bj{
        width: 80%;
        margin-left: 15%;
        height: 100%;
        background: #000000;
        opacity: 0.4;
        position: absolute;
      }
      ul{
        width: 65%;
        height: 100%;
        text-align: right;
        /*background: #000;*/
        display: inline-block;
        padding: 0;
        margin-left: 2%!important;
        position: relative;
        margin-bottom: 0;
        li{
             display: block!important;
             width:100%;
          margin: 0 !important;
          padding: .1rem 0;
          /*border-bottom: 1px solid #0c0c92;*/
        }
        ul{
          margin-left: 0 !important;
          width: 100%;
          font-size: .3rem;
          color: #dcdada;
        }
    }
      .lower::before {
        color: #fff !important;
        top: .95rem;
        right: 2.3rem;
      }

      .upper::before {
        color: #fff !important;
        top: .95rem;
        right: 2.3rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/brand-products/head.vue